import { validateRutChilenoConDetalle } from "./utils/rutChileno";

const backgroundColors = [
  "#F44336",
  "#FF4081",
  "#9C27B0",
  "#673AB7",
  "#3F51B5",
  "#2196F3",
  "#03A9F4",
  "#00BCD4",
  "#009688",
  "#4CAF50",
  "#8BC34A",
  "#CDDC39",
  "#FFC107",
  "#FF9800",
  "#FF5722",
  "#795548",
  "#9E9E9E",
  "#607D8B"
];

const defaultColor = "#b5b5b5";

export function setColor(user) {
  return user ? (user.color ? user.color : backgroundColors[user.nombre.length % backgroundColors.length]) : defaultColor
}


export function toArray(rows) {
  return Object.keys(rows).map(key => rows[key]);
}


export function randomId() {
  return Math.random()
    .toString(36)
    .replace(/[^a-z]+/g, "")
    .substr(2, 10);
}

/**
 * Genera una contraseña aleatoria que cumple la política de complejidad del
 * backend (Password::min(8)->mixedCase()->numbers()->symbols()):
 * al menos una minúscula, una mayúscula, un dígito y un símbolo.
 *
 * Usa window.crypto.getRandomValues (CSPRNG) para una selección segura.
 *
 * @param {number} length Largo deseado (mínimo 12 por seguridad).
 * @returns {string}
 */
export function generateStrongPassword(length = 16) {
  const lower = "abcdefghijkmnopqrstuvwxyz"; // sin l
  const upper = "ABCDEFGHJKLMNPQRSTUVWXYZ"; // sin I, O
  const digits = "23456789"; // sin 0, 1
  const symbols = "!@#$%&*?-_=+";
  const all = lower + upper + digits + symbols;

  const len = Math.max(12, length);
  const crypto = window.crypto || window.msCrypto;

  const pick = (set) => {
    const arr = new Uint32Array(1);
    crypto.getRandomValues(arr);
    return set[arr[0] % set.length];
  };

  // Garantizar al menos un caracter de cada categoría.
  const chars = [pick(lower), pick(upper), pick(digits), pick(symbols)];
  while (chars.length < len) {
    chars.push(pick(all));
  }

  // Mezcla Fisher-Yates con aleatoriedad criptográfica.
  for (let i = chars.length - 1; i > 0; i--) {
    const arr = new Uint32Array(1);
    crypto.getRandomValues(arr);
    const j = arr[0] % (i + 1);
    [chars[i], chars[j]] = [chars[j], chars[i]];
  }

  return chars.join("");
}

export function formatDate(current_datetime, withHour = true) {
  current_datetime = new Date(current_datetime)
  let day = null;
  let month = null;

  let hours = null;
  let minutes = null;
  let seconds = null;



  if (current_datetime.getDate() < 10) {
    day = '0' + current_datetime.getDate();
  } else {
    day = current_datetime.getDate();
  }


  if (current_datetime.getMonth() < 10) {
    month = '0' + (parseInt(current_datetime.getMonth()) + 1);
  } else {
    month = parseInt(current_datetime.getMonth());
  }

  if (current_datetime.getHours() < 10) {
    hours = '0' + current_datetime.getHours();
  } else {
    hours = current_datetime.getHours();
  }


  if (current_datetime.getMinutes() < 10) {
    minutes = '0' + current_datetime.getMinutes();
  } else {
    minutes = current_datetime.getMinutes();
  }

  if (current_datetime.getSeconds() < 10) {
    seconds = '0' + current_datetime.getSeconds();
  } else {
    seconds = current_datetime.getSeconds();
  }

  let dateHour = withHour ? hours + ":" + minutes + ":" + seconds : '';
  let formatted_date = day + "/" + month + "/" + current_datetime.getFullYear() + " " + dateHour;

  return formatted_date;
}

export function setStatusColor(card) {
  if (card.severidad) {
    if (card.severidad == "0") {
      return "#73e079";
    }

    if (card.severidad == "1") {
      return "#ded74f";
    }

    if (card.severidad == "2") {
      return "#fdaf44";
    }

    if (card.severidad == "3") {
      return "#f66";
    }

    if (card.severidad == "4") {
      return "#5da9ff";
    }
  } else {
    if (card.prioridad == "0") {
      return "#73e079";
    }

    if (card.prioridad == "1") {
      return "#ded74f";
    }

    if (card.prioridad == "2") {
      return "#fdaf44";
    }

    if (card.prioridad == "3") {
      return "#f66";
    }

    if (card.prioridad == "4") {
      return "#5da9ff";
    }
  }


  return "#e9ece9"

}


/**
 * Caracteres reservados de XML que rompen el documento tributario (DTE): < > & " '
 */
export const XML_RESERVED_REGEX = /[<>&"']/;

/**
 * @param {string|null|undefined} v
 * @returns {boolean} true si el texto no contiene caracteres reservados de XML
 */
export function isXmlSafe(v) {
  return !v || !XML_RESERVED_REGEX.test(v);
}

/**
 * Reglas de validación para Vuetify (:rules). Opciones soportadas:
 * - required: campo obligatorio
 * - limit:    largo MÍNIMO de caracteres
 * - max:      largo MÁXIMO de caracteres (estándar SII)
 * - email:    formato de correo válido
 * - rut:      RUT chileno con dígito verificador (módulo 11)
 * - phone:    teléfono (solo dígitos, espacios y ( ) + -)
 * - xmlSafe:  bloquea caracteres que rompen el XML del DTE (< > & " ')
 * Todas las validaciones de contenido se omiten cuando el campo está vacío;
 * la obligatoriedad se maneja con `required`.
 */
export function setRules(name, rules){
  let rule = []
  if(rules.required){
    rule.push(v => !!v || "El campo " + name + " es requerido");
  }
  if(rules.limit){
    rule.push(v => (v && v.length >= rules.limit) || "El campo " + name + " requiere un minimo de "+ rules.limit +" caracteres");
  }
  if(rules.max){
    rule.push(v => !v || v.length <= rules.max || "El campo " + name + " admite un máximo de " + rules.max + " caracteres");
  }
  if(rules.email){
      rule.push(v => !v || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) || 'Ingrese un correo electrónico válido');
  }
  if(rules.rut){
      rule.push(v => {
        if(!v) return true;
        const detalle = validateRutChilenoConDetalle(v);
        return detalle.valid || detalle.message;
      });
  }
  if(rules.phone){
      rule.push(v => !v || /^[\d\s()+-]+$/.test(v) || "El campo " + name + " solo admite números, espacios, ( ), + y -");
  }
  if(rules.giro){
      rule.push(v => !v || /^[A-Za-z0-9ñÑáéíóúÁÉÍÓÚüÜ\s]*$/.test(v) || "El campo " + name + " solo admite letras, números y espacios");
  }
  if(rules.comuna){
      rule.push(v => !v || /^[A-Za-zñÑáéíóúÁÉÍÓÚüÜ\s]*$/.test(v) || "El campo " + name + " solo admite letras y espacios");
  }
  if(rules.username){
      rule.push(v => !v || /^[A-Za-z0-9-]*$/.test(v) || "El campo " + name + " solo admite letras, números y guion (-)");
  }
  if(rules.xmlSafe){
      rule.push(v => isXmlSafe(v) || 'No se permiten los caracteres < > & " \' (rompen el documento tributario)');
  }
  return rule
}

export function resolucion() {
  if (window.innerWidth < 960) {
    return true
  } else {
    return false
  }
}

export function onlyNumber($event) {
  let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
    if (keyCode < 48 || keyCode > 57) { // && keyCode !== 46 / 46 is dot
        $event.preventDefault();
    }
}

export function onlyNumberAndDash($event) {
  let keyCode = $event.keyCode ? $event.keyCode : $event.which
  if (
    (keyCode < 48 || keyCode > 57) &&
    keyCode !== 45 &&
    keyCode !== 107 &&
    keyCode !== 75
  ) {
    // && keyCode !== 46 / 46 is dot
    $event.preventDefault()
  }
}

export function Number_Dash_Letters_Space($event) {
  let keyCode = $event.keyCode ? $event.keyCode : $event.which
  if (
    (keyCode < 65 || keyCode > 90) && //letras
    (keyCode < 48 || keyCode > 57) && //numeros
    keyCode !== 45 &&
    keyCode !== 107 &&
    keyCode !== 75 &&
    keyCode !== 32 //espacio
  ) {
    // && keyCode !== 46 / 46 is dot
    $event.preventDefault()
  }
}

export function onlyNumberAndDot($event) {
  let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
    if ((keyCode < 48 || keyCode > 57) && keyCode !== 46 ) { // && keyCode !== 46 / 46 is dot
        $event.preventDefault();
    }
}

export function formatNumber(number) {
  number += ""
  var x = number.split(".")
  var x1 = x[0]
  var x2 = x.length > 1 ? "." + x[1] : ""
  var rgx = /(\d+)(\d{3})/
  while (rgx.test(x1)) {
    x1 = x1.replace(rgx, "$1" + "." + "$2")
  }

  return x1 + x2
}

export function changeSeparator(number) {
  number += ""
  var x = number.split(".")
  var x1 = x[0]
  var x2 = x[1]
  if(number == 0){
      return 0
  }else if(x.length == 1) {
      return number+",00"
  }else {
      return x1 + "," + x2
  }

}


export function convertToPlain(html) {
  // Create a new div element
  var tempDivElement = document.createElement("div");

  // Set the HTML content with the given value
  tempDivElement.innerHTML = html;

  // Retrieve the text property of the element
  return tempDivElement.textContent || tempDivElement.innerText || "";

}

export function formatRut(rut) {
  let value = rut.replace(/\./g, "").replace("-", "");

  if (value.match(/^(\d{2})(\d{3}){2}(\w{1})$/)) {
    value = value.replace(/^(\d{2})(\d{3})(\d{3})(\w{1})$/, "$1$2$3-$4");
  } else if (value.match(/^(\d)(\d{3}){2}(\w{0,1})$/)) {
    value = value.replace(/^(\d)(\d{3})(\d{3})(\w{0,1})$/, "$1$2$3-$4");
  } else if (value.match(/^(\d)(\d{3})(\d{0,2})$/)) {
    value = value.replace(/^(\d)(\d{3})(\d{0,2})$/, "$1$2$3");
  } else if (value.match(/^(\d)(\d{0,2})$/)) {
    value = value.replace(/^(\d)(\d{0,2})$/, "$1$2");
  }
  return value;

}

export function formatearFechaNew(fecha, hour = true) {
  try {
    let dateFormatted = null;
    const unixTimestamp = new Date(fecha * 1000);
    // console.log("1.formatearFecha, unixTimestamp ------------------", unixTimestamp);
    // Verificar si el parámetro es un timestamp Unix válido
    if (!isNaN(unixTimestamp)) {
    //   console.log("2.formatearFecha, es unix", fecha);
      // Crear un objeto Date a partir del timestamp Unix
      const fecha_unix = new Date(fecha * 1000);

      // Obtener el día, mes, año, horas y minutos
      const dia = ("0" + fecha_unix.getDate()).slice(-2);
      const mes = ("0" + (fecha_unix.getMonth() + 1)).slice(-2);
      const year = fecha_unix.getFullYear();
      if(hour == true){
        const horas = ("0" + fecha_format.getHours()).slice(-2);
        const minutos = ("0" + fecha_format.getMinutes()).slice(-2);
        dateFormatted = `${dia}/${mes}/${year} ${horas}:${minutos}`;
      }else{
        // console.log("hour es false: ", hour);
        dateFormatted = `${dia}/${mes}/${year}`;
      }

      // Formatear la fecha como dd/mm/yyyy hh:mm
      return dateFormatted;
    } else {
      // console.log("4.formatearFecha, es normal", fecha);
      
      const fecha_sin_zona = fecha.replace(/ clt| clst/g, '');

      // Si no es un timestamp Unix, intentar crear un objeto Date directamente
      // const fecha_format = new Date(fecha_sin_zona);
      const fecha_format = new Date(fecha_sin_zona.replace(/(\d{2})\/(\d{2})\/(\d{4}) (\d{2}):(\d{2})/, '$3-$2-$1T$4:$5'));
      // console.log("5.1formatearFecha, fecha_sin_zona: ", fecha_sin_zona);

      // console.log("5.formatearFecha, formatearFecha: ", fecha);
      // console.log("6.formatearFecha, fecha_format: ", fecha_format);


      // Obtener el día, mes, año, horas y minutos
      const dia = ("0" + fecha_format.getDate()).slice(-2);
      const mes = ("0" + (fecha_format.getMonth() + 1)).slice(-2);
      const year = fecha_format.getFullYear();
      // console.log("hour: : ", hour);

      if(hour == true){
        const horas = ("0" + fecha_format.getHours()).slice(-2);
        const minutos = ("0" + fecha_format.getMinutes()).slice(-2);
        dateFormatted = `${dia}/${mes}/${year} ${horas}:${minutos}`;
      }else{
        console.log("hour es false: ", hour);
        dateFormatted = `${dia}/${mes}/${year}`;
      }

      // Formatear la fecha como dd/mm/yyyy hh:mm
      return dateFormatted;
    }
  } catch (error) {
    console.log("7.formatearFecha, formatearFecha: catch ", fecha);
    return null;
  }
}


export {
  normalizeRutChileno,
  calcularDvRutChileno,
  isValidRutChileno,
  validateRutChilenoConDetalle,
  mensajeFormatosRutChileno,
  rutChilenoFormateado,
} from "./utils/rutChileno";

export function convertToUnixTimestampOrValidate(dateString) {
  // Verificar si es un timestamp Unix
  if (dateString.length === 10 && /^\d+$/.test(dateString)) {
      return parseInt(dateString, 10); // Ya es un timestamp Unix
  } else {
      // Convertir fecha normal a timestamp Unix
      const timestamp = Date.parse(dateString.replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$2/$1/$3'));
      if (!isNaN(timestamp)) {
          return Math.floor(timestamp / 1000); // Convertir a segundos
      } else {
          // La fecha no es válida
          console.error('Fecha no válida:', dateString);
          return null;
      }
  }
}


/**
 * Metadatos de presentación para el estado de una habilitación
 * (cliente_servicio.estado): 0=Pendiente, 1=Habilitado, 2=Suspendido,
 * 3=Eliminado. Fuente única para pintar chips/badges de estado de servicio
 * de forma consistente en toda la app.
 */
export const ESTADO_CLIENTE_SERVICIO_META = {
  0: { text: "Pendiente", color: "info", icon: "mdi-clock-outline" },
  1: { text: "Habilitado", color: "success", icon: "mdi-check-circle" },
  2: { text: "Suspendido", color: "orange darken-2", icon: "mdi-pause-circle" },
  3: { text: "Eliminado", color: "error", icon: "mdi-delete-circle" },
};

export function estadoClienteServicioMeta(estado) {
  return (
    ESTADO_CLIENTE_SERVICIO_META[estado] || {
      text: "Desconocido",
      color: "grey",
      icon: "mdi-help-circle",
    }
  );
}
